import { CheckCircle } from "@mui/icons-material";
import { FormActions } from "../../components/common/FormActions";
import { createColumn, createViewEdit } from "../../utils/helpers";
import { URL_ROLES } from "../../utils/urls";
import { API_ACCOUNTS_ROLES_REGISTER } from "../../utils/apis";

export const useRoles = ({ id }) => {
  const tableColumns = () => [
    ...["name", "actions"].map((item) => createColumn(item)),
  ];

  const tableData = (data: any) =>
    data?.map((item: any) => ({
      name: item?.name || "Unnamed Role",
      is_active: item.is_active ? "Active" : "Inactive",
      actions: <FormActions actions={createViewEdit(URL_ROLES, item?.id)} />,
    }));

  const viewData = (item: any) => {
    const rolePermissions = item?.permissions || [];

    // If no permissions at all
    if (!rolePermissions || rolePermissions.length === 0) {
      return {
        name: item?.name || "Unknown Role",
        permissions: <em>No permissions assigned</em>,
      };
    }

    // Sort permissions alphabetically by name for better UX
    const sortedPermissions = [...rolePermissions].sort((a: any, b: any) =>
      a.name.localeCompare(b.name),
    );

    return {
      name: item?.name || "Unknown Role",
      "Permissions Granted": (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
            gap: "12px",
            padding: "16px",
            backgroundColor: "#f9f9f9",
            borderRadius: "8px",
            border: "1px solid #eee",
            maxHeight: "600px",
            overflowY: "auto",
          }}
        >
          {sortedPermissions.map((perm: any) => (
            <div
              key={perm.id}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                fontSize: "14px",
              }}
            >
              <CheckCircle fontSize="small" style={{ color: "#1890ff" }} />
              <span style={{ wordBreak: "break-word" }}>
                <strong>{perm.name}</strong>
              </span>
            </div>
          ))}
        </div>
      ),
    };
  };

  const formRoute = "/roles/create";
  const customApi = `${API_ACCOUNTS_ROLES_REGISTER}${id}`;

  return { tableColumns, tableData, formRoute, viewData, customApi };
};
